module.exports = __webpack_public_path__ + "static/media/value_prop_img_2.fe56db10.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/TCH-WEB/value_prop_img_2.jpg
// module id = 1301
// module chunks = 0